var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"checkbox",attrs:{"type":"button","checked":_vm.checked},on:{"click":_vm.toggle}},[(_vm.checked)?_c('i',{staticClass:"far fa-check-square"}):_c('i',{staticClass:"far fa-square"})])}
var staticRenderFns = []

export { render, staticRenderFns }